module.exports = __webpack_public_path__ + "img/pr-4.6bb8b7de.png";